import React, { useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import AccountsPage from '../accounts/AccountsPage';
import {gridOutline, timeOutline, wallet } from 'ionicons/icons';
import TransactionHistoryPage from '../transaction-history/TransactionHistory';

import { t } from 'i18next';
import { useDispatch } from '../../services/redux/store';
import { setSelectedTab } from '../../services/redux/slices/selected-tab/selected-tab';
import Hub from '../hub/Hub';



const TabsPage: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        // Update Redux state based on current route
        const updateSelectedTab = () => {
            const pathname = location.pathname;
            if (pathname.includes('/tabs/accounts')) {
                dispatch(setSelectedTab('accounts'));
            } 
            else if (pathname.includes('/tabs/hub')) {
                dispatch(setSelectedTab('hub'));

            } else if (pathname.includes('/tabs/history')) {
                dispatch(setSelectedTab('history'));
            } 
        };

        // Update on mount and route changes
        updateSelectedTab();
    }, [location.pathname, dispatch]);

    return (
        <IonTabs>
            <IonRouterOutlet>
                <Route exact path="/">
                    <Redirect to="/tabs/accounts" />
                </Route>
                <Route exact path="/tabs/accounts">
                    <AccountsPage />
                </Route>

                  <Route exact path="/tabs/hub">
                    <Hub />
                </Route>
        
           
                <Route exact path="/tabs/history">
                    <TransactionHistoryPage />
                </Route>
              
            </IonRouterOutlet>

            <IonTabBar slot="bottom">
                <IonTabButton tab="accounts" href="/tabs/accounts">
                    <IonIcon icon={wallet} />
                    <IonLabel>{t('Tabs.tab1.label')}</IonLabel>
                </IonTabButton>

                 <IonTabButton tab="hub" href="/tabs/hub">
                    <IonIcon icon={gridOutline} />
                    <IonLabel>{t('Tabs.tab5.label')}</IonLabel>
                </IonTabButton>

                 <IonTabButton tab="history" href="/tabs/history">
                    <IonIcon icon={timeOutline} />
                    <IonLabel>{t('Tabs.tab4.label')}</IonLabel>
                </IonTabButton>


                {/* <IonTabButton tab="receive" href="/tabs/receive">
                    <IonIcon icon={addOutline} />
                    <IonLabel>{t('Tabs.tab2.label')}</IonLabel>
                </IonTabButton> */}

                {/* <IonTabButton tab="shops" href="/tabs/shops">
                    <IonIcon icon={storefrontOutline} />
                    <IonLabel>{t('Tabs.tab3.label')}</IonLabel>
                </IonTabButton> */}
            </IonTabBar>
        </IonTabs>
    );
};

export default TabsPage;